import { EventContextProvider } from "@codat/analytics";
import { ProductPagesProps } from "codat-product-pages-ui/App";
import * as React from "react";
import { Route, Switch } from "react-router-dom";

import { paths } from "components/App/paths";
import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";
import Page from "components/Page";
import PageLoadingSkeleton from "components/PageLoadingSkeleton";
import ProductPagesHeader from "pages/ProductPages/ProductPagesHeader";

const RemoteApiCoveragePage = React.lazy(
  () => import("codat-knowledge-ui/IntegrationCoverage")
);

const ProductPagesApp = React.lazy(() => import("codat-product-pages-ui/App"));

const ProductPages = ({ productName }: ProductPagesProps) => {
  return (
    <EventContextProvider name="Product Pages">
      <Page header={<ProductPagesHeader productName={productName} />}>
        <React.Suspense fallback={<PageLoadingSkeleton />}>
          <ErrorBoundary>
            <Switch>
              <Route
                path={`${paths.products.ACCOUNTING_API}${paths.products.NESTED_ROUTES.API_COVERAGE}`}
                render={() => (
                  <RemoteApiCoveragePage
                    integrationType="accounting"
                    pageTitle="API coverage"
                    loadAsRemote
                    useRouterV5
                  />
                )}
              />
              <Route
                path={`${paths.products.BANKING_API}${paths.products.NESTED_ROUTES.API_COVERAGE}`}
                render={() => (
                  <RemoteApiCoveragePage
                    integrationType="banking"
                    pageTitle="API coverage"
                    loadAsRemote
                    useRouterV5
                  />
                )}
              />
              <Route
                path={`${paths.products.COMMERCE_API}${paths.products.NESTED_ROUTES.API_COVERAGE}`}
                render={() => (
                  <RemoteApiCoveragePage
                    integrationType="commerce"
                    pageTitle="API coverage"
                    loadAsRemote
                    useRouterV5
                  />
                )}
              />
              <Route
                path="*"
                render={() => <ProductPagesApp productName="" />}
              />
            </Switch>
          </ErrorBoundary>
        </React.Suspense>
      </Page>
    </EventContextProvider>
  );
};
export default ProductPages;
